import { useState } from 'react'
import { Form, Button, Spinner, Alert, Badge, Card, Modal } from 'react-bootstrap'
import client from '../../api/client'

const PIPELINE_LABELS = {
  'text-generation': 'Génération de texte',
  'conversational': 'Conversationnel',
  'image-generation': "Génération d'images",
  'text-to-image': 'Texte vers image',
  'automatic-speech-recognition': 'Reconnaissance vocale',
  'audio-classification': 'Classification audio'
}

export function getPipelineLabel(tag) {
  return PIPELINE_LABELS[tag] || tag
}

function HFSearchModal({ show, onHide, onModelAdded, onError }) {
  const [searchQuery, setSearchQuery] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [searching, setSearching] = useState(false)

  const handleClose = () => {
    setSearchQuery('')
    setSearchResults([])
    setSearching(false)
    onHide()
  }

  const handleSearch = async () => {
    if (!searchQuery.trim()) return
    setSearching(true)
    try {
      const response = await client.get('/admin/api/v1/hf-models/search', {
        params: { query: searchQuery, limit: 10 }
      })
      setSearchResults(response.data || [])
    } catch (err) {
      console.error('Error searching HF catalogue:', err)
      onError('Erreur lors de la recherche dans le catalogue HF')
    } finally {
      setSearching(false)
    }
  }

  const handleAddModel = async (hfModelId) => {
    try {
      const response = await client.post('/admin/api/v1/hf-models', {
        hf_model_id: hfModelId
      })
      onModelAdded(response.data.name)
      handleClose()
    } catch (err) {
      console.error('Error adding model:', err)
      onError("Erreur lors de l'ajout du modèle")
    }
  }

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Ajouter un modèle depuis Hugging Face</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Rechercher dans le catalogue HF</Form.Label>
          <div className="d-flex gap-2">
            <Form.Control
              type="text"
              placeholder="Ex: meta-llama/Meta-Llama-3-8B-Instruct"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            />
            <Button
              variant="primary"
              onClick={handleSearch}
              disabled={searching || !searchQuery.trim()}
            >
              {searching ? <Spinner animation="border" size="sm" /> : 'Rechercher'}
            </Button>
          </div>
        </Form.Group>

        {searchResults.length > 0 && (
          <div>
            <h6 className="mb-3">Résultats ({searchResults.length})</h6>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {searchResults.map((result, index) => (
                <Card key={index} className="mb-2">
                  <Card.Body className="p-3">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="flex-grow-1">
                        <strong>{result.name}</strong>
                        <br />
                        <code className="small text-muted">{result.model_id}</code>
                        <br />
                        <div className="mt-2">
                          <Badge bg="info" className="me-2">{getPipelineLabel(result.pipeline_tag)}</Badge>
                          <small className="text-muted">
                            {result.downloads.toLocaleString()} downloads |
                            {result.likes.toLocaleString()} likes
                          </small>
                        </div>
                      </div>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleAddModel(result.model_id)}
                      >
                        Ajouter
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              ))}
            </div>
          </div>
        )}

        {searchResults.length === 0 && !searching && searchQuery && (
          <Alert variant="info">
            Aucun résultat trouvé. Essayez un autre terme de recherche.
          </Alert>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default HFSearchModal
